import React, { ButtonHTMLAttributes } from 'react';

interface ITrapeziumButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  customClass?: string;
}

export const TrapeziumButton = (props: ITrapeziumButton) => {
  const { children, customClass } = props;
  return (
    <button
      {...props}
      className={`flex justify-center items-center gap-1 w-[100px] h-[38px] bg-[#F8973A] text-sm text-white text-center rounded-xl transform skew-x-[-20deg] transition-all duration-300 cursor-pointer ${customClass}`}
    >
      {children}
    </button>
  );
};
